module.exports = __webpack_public_path__ + "img/event-view-014.feec6056.png";